<template>
  <NuxtPwaManifest />
  <div class="navbar-wrapper">
    <Navbar />
  </div>

  <div class="text-center m-2 page-content">
    <slot />
  </div>
</template>

<style>
/* fix to make this work with smaller screens */
.p-toast {
  max-width: calc(100vw - 40px);
}
</style>
